
import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,TableContainer,
          Paper,
    Checkbox, FormControlLabel,
} from "@material-ui/core";
import { Card, Box } from "@material-ui/core";
import LessonService from "./Locality/Service/lessonService";
import AddClassService from "./Locality/Service/addClassService";
import SubjectService from "./Locality/Service/subjectService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Lesson() {
    const tableHeaders = ['class', 'Subject', 'objectives', 'materialRequired', 'stepsAndProcedures', 'Control Of Error','Point Of Interest', 'Edit', 'Delete'];
    const [images, setImages] = useState('');
    const [imageslist, setImagesList] = useState([]);
    const [message, setMessage] = useState("");
    const classes = useStyles();
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);

    const [lessonList, setLessonList] = useState([]);
    const [dueDate, setFormDueDate] = useState("");
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(100);
    const current = new Date();
    var [classId, setClassId] = useState("");
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    var [dateValue, setDateValue] = useState(date);
    const [lessonId, setLessonId] = useState('');
    const [year, month, day] = date.split("-");
    //     const [images, setImages] = useState([]);
    //  const [imageslists, setImagesLists] = useState([]);
    const [lesson, setLesson] = useState({
        lesson: '',
        subjectId: '',
        images: [],
        objectives: [],
        video: '',
        classId: '',
        materialRequired: [],
        stepsAndProcedures: [],
        controlOfError: [],
        pointOfInterest: [],

    });

    const validationSchema = Yup.object().shape({
        lesson: Yup.string().required('lesson is required'),
        images: Yup.array(),
        objectives: Yup.array().of(Yup.string().required("Can't be empty")),
        video: Yup.string(),
        remarks: Yup.string(),
        classId: Yup.string().required('Class Name is required'),
        materialRequired: Yup.array().of(Yup.string().required("Can't be empty")),
        stepsAndProcedures: Yup.array().of(Yup.string().required("Can't be empty")),
        controlOfError: Yup.array().of(Yup.string()),
        pointOfInterest: Yup.array().of(Yup.string()),
    });
    const verifyeetnt = () => {
        console.log(formik)
    }
    const handleOpen = (status) => {


        if (status) {
            setLesson({
                lesson: '',
                images: [],
                objectives: [],
                video: '',
                classId: '',
                remarks: '',
                materialRequired: [],
                stepsAndProcedures: [],
                pointOfInterest: [],
                controlOfError: []
            })
        }

        setOpen(true);
    };
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    useEffect(() => {
        getLessonList();
        getSubjectList();
        getAddClassList();
        return () => {
            setSubjectList([]);
            setLessonList([]);
            setStudentList([]);
            imageslist.forEach(url => URL.revokeObjectURL(url));

        }
    }, [imageslist]);
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormDueDate(value);
    };
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setImages(selectedFiles);

        // const previewUrls = selectedFiles.map(file => URL.createObjectURL(file));
        // setImagesList(previewUrls);
    };


    const handleUpload = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setMessage("Please select images first.");
            return;
        }

        // Create FormData and append each file
        const formData = new FormData();
        if (images.length > 0) {
            const image = images[0];
            formData.append(`image`, image);

            formData.append(`imageName`, image.name);
            // images.forEach((image, index) => {
            //   formData.append(`images`, image); // Append each file to the form
            // });

            try {
                // Send the images to the API
                LessonService.uploadImage(formData).then((res) => {

                    alert(`Images uploaded successfully`);
                    setImagesList((prev) => [...prev, res.url]);


                }).catch((err) => {
                    alert(err.message);
                });

                //   const response = await fetch("http://localhost:3000/upload-multiple", {
                //     method: "POST",
                //     body: formData,
                //   });

                //   if (response.ok) {
                //     const result = await response.json();
                //     setMessage(`Images uploaded successfully: ${result.fileUrls.join(", ")}`);
                //   } else {
                //     setMessage("Failed to upload images.");
                //   }
            } catch (error) {
                console.error("Error uploading images:", error);
                setMessage("An error occurred while uploading the images.");
            }
        }

    };
    const getLessonList = () => {
        LessonService.getAllLesson().then((res) => {
            setLessonList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    //   const getLessonList = () => {

    //     LessonService.getAllLesson()
    //       .then((res) => {

    //         const formattedEvents = res.map((event) => {
    //           const formattedDate = event.date ? formatDate(event.date) : "";
    //           return { ...event, date: formattedDate };
    //         });

    //         setEventList(formattedEvents);
    //       })
    //       .catch((err) => {
    //         setError(err.message);
    //       });
    //   };
    const formatDate = (date) => {
        const [year, month, day] = date.split("-"); // Split the date string (YY-MM-DD)
        return `${day}-${month}-${year.slice(2)}`; // Return in DD-MM-YY format
    };

    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const removeImage = (index) => {
        const updatedList = [...imageslist];
        updatedList.splice(index, 1);
        setImagesList(updatedList);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSubjectList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        SubjectService.getAllSubject().then((res) => {

            setSubjectList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editLesson = (lesson) => {
        lesson.classId = lesson.classId ? lesson.classId._id : '';
        setLesson(lesson);
        handleOpen(false);
        // setIsEditMode(true)
    }

    const deleteLesson = (lessondelete) => {
        if (lessondelete) {
            LessonService.deleteLesson(lessondelete).then((res) => {
                getLessonList()
            }).catch((err) => {
            });
        }
    }


    const formik = useFormik({
        initialValues: lesson,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            if (lesson._id) {
                LessonService.upadeLesson(values).then((res) => {
                    handleClose();
                    getLessonList();
                    resetForm()
                    alert("Lesson Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                values.images = imageslist;
                LessonService.creteLesson(values).then((res) => {
                    getLessonList();
                    resetForm();
                    handleClose();
                    setImagesList([]);
                    alert(" Lesson Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });
    const test = () => {
        console.log(formik)
    };

    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {
            "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
            "date": dateValue
        }
        LessonService.creteLesson(keys).then((res) => {

            setDateValue("");
            setStudentList([]);
            alert(" Event Successfully.");
        }).catch((err) => {

            alert(err.response.data.message);
        });
    };
    return (

        <>
            <PageTitle title="Lessons" button={<Button

                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Lesson
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {/* {calenderAssignmentList.slice(pg * rpg, pg * rpg + rpg).map((calenderassignment) => ( */}

                                {lessonList.slice(pg * rpg, pg * rpg + rpg).map((lesson) => (
                                    <TableRow key={lesson._id}>

                                        <TableCell className="pl-3 fw-normal" >{lesson.classId ? lesson.classId.className : ''}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{lesson.lesson}</TableCell>


                                        <TableCell className="pl-3 fw-normal" >{lesson.objectives.join(",")}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{lesson.materialRequired.join(",")}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{lesson.stepsAndProcedures.join(",")}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{lesson.pointOfInterest.join(",")}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{lesson.controlOfError.join(",")}</TableCell>

                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editLesson(lesson)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteLesson(lesson)} />
                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 1000000]}
                            count={lessonList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Lesson</DialogTitle>


                <DialogContent style={{ width: 600 }}>
                    <FormControl className={classes.formControl} fullWidth="true"
                    >
                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="classId"
                            label="selectClass"

                            value={formik.values.classId}
                            onChange={e => { formik.handleChange(e); }}


                            error={formik.touched.classId && Boolean(formik.errors.classId)}
                            helperText={formik.touched.classId && formik.errors.classId}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>

                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}

                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth="true"
                    >
                        <InputLabel id="demo-simple-select-label">Select Subject</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="subjectId"
                            label="selectClass"
                            value={formik.values.subjectId}
                            onChange={formik.handleChange}
                            error={formik.touched.subjectId && Boolean(formik.errors.subjectId)}
                            helperText={formik.touched.subjectId && formik.errors.subjectId}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>

                            {subjectList.map(({ _id, subject }) => (
                                <MenuItem key={_id} value={_id}>{subject}

                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="lesson"
                        name="lesson"
                        label="Lesson"
                        type="text"
                        variant="standard"
                        value={formik.values.lesson}
                        onChange={formik.handleChange}
                        error={formik.touched.lesson && Boolean(formik.errors.lesson)}
                        helperText={formik.touched.lesson && formik.errors.lesson}
                    />
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="objectives"
                        name="objectives"
                        label="Objectives"
                        type="text"
                        variant="standard"
                        value={formik.values.objectives}
                        onChange={formik.handleChange}
                        error={formik.touched.objectives && Boolean(formik.errors.objectives)}
                        helperText={formik.touched.objectives && formik.errors.objectives}
                    /> */}
                    <Grid container spacing={4}>
                        <Grid item lg={6} xs={12}>
                            <DynamicListInput
                                label="Objectives"
                                name="objectives"
                                values={formik.values.objectives}
                                onChange={(val) => formik.setFieldValue("objectives", val)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>

                            <DynamicListInput
                                label="Material Required"
                                name="materialRequired"
                                values={formik.values.materialRequired}
                                onChange={(val) => formik.setFieldValue("materialRequired", val)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <DynamicListInput
                                label="Steps and Procedures"
                                name="stepsAndProcedures"
                                values={formik.values.stepsAndProcedures}
                                onChange={(val) => formik.setFieldValue("stepsAndProcedures", val)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>

                            <DynamicListInput
                                label="Control of Error"
                                name="controlOfError"
                                values={formik.values.controlOfError}
                                onChange={(val) => formik.setFieldValue("controlOfError", val)}
                            />
                        </Grid>
                    </Grid>

                    <DynamicListInput
                        label="Point of Interest"
                        name="pointOfInterest"
                        values={formik.values.pointOfInterest}
                        onChange={(val) => formik.setFieldValue("pointOfInterest", val)}
                    />
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="materialRequired"
                        name="materialRequired"
                        label="Material Required"
                        type="text"
                        variant="standard"
                        value={formik.values.materialRequired}
                        onChange={formik.handleChange}
                        error={formik.touched.materialRequired && Boolean(formik.errors.materialRequired)}
                        helperText={formik.touched.materialRequired && formik.errors.materialRequired}
                    /> */}
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="stepsAndProcedures"
                        name="stepsAndProcedures"
                        label="Steps And Procedures"
                        type="text"
                        variant="standard"
                        value={formik.values.stepsAndProcedures}
                        onChange={formik.handleChange}
                        error={formik.touched.stepsAndProcedures && Boolean(formik.errors.stepsAndProcedures)}
                        helperText={formik.touched.stepsAndProcedures && formik.errors.stepsAndProcedures}
                    /> */}

                    <TextField fullWidth
                        margin="dense"
                        id="video"
                        name="video"
                        label="Video Link"
                        type="text"
                        variant="standard"
                        value={formik.values.video}
                        onChange={formik.handleChange}
                        error={formik.touched.video && Boolean(formik.errors.video)}
                        helperText={formik.touched.video && formik.errors.video}
                    />
                    <TextField fullWidth
                        margin="dense"
                        id="remarks"
                        name="remarks"
                        label="Remarks"
                        type="text"
                        variant="standard"
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                    />
                    <input fullWidth
                        type="file"
                        accept="image/*"
                        // Enable multiple file selection
                        onChange={handleFileChange}
                    />
                    <Button style={{ backgroundColor: 'rgb(21 61 96)', color: 'white', border: 'none' }} onClick={handleUpload}>Upload</Button>

                    {/* {imageslist.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                            {imageslist.map((url, index) => (
                                <img
                                    key={index}
                                    src={url}
                                    alt={`Uploaded ${index + 1}`}
                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                />
                            ))}
                        </div>
                    )} */}
                    {imageslist.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: 10 }}>
                            {imageslist.map((url, index) => (
                                <div key={index} style={{ position: 'relative' }}>
                                    <img
                                        src={url}
                                        alt={`Preview ${index + 1}`}
                                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 4 }}
                                    />
                                    <Button
                                        size="small"
                                        style={{ position: 'absolute', top: -5, right: -5, minWidth: 20, padding: 0 }}
                                        onClick={() => removeImage(index)}
                                    >
                                        ❌
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        type="submit" onClick={formik.handleSubmit}
                    // onClick={test}
                    >Add</Button>
                </DialogActions>

            </Dialog>
        </>
    );
}


const DynamicListInput = ({ label, name, values, onChange }) => {
    // Ensure there's at least one input box when the component first mounts
    useEffect(() => {
        if (!values || values.length === 0) {
            onChange([""]);
        }
    }, [values, onChange]);

    const handleAdd = () => onChange([...values, ""]);

    const handleRemove = index => {
        const newList = [...values];
        newList.splice(index, 1);
        onChange(newList);
    };

    const handleInputChange = (e, index) => {
        const newList = [...values];
        newList[index] = e.target.value;
        onChange(newList);
    };

    return (
        <div style={{ marginTop: 10 }}>
            <label>{label}</label>
            {values.map((val, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 5 }}>
                    <TextField
                        fullWidth
                        value={val}
                        onChange={(e) => handleInputChange(e, index)}
                    />
                   {(values.length>1 && index != 0)  ? <DeleteIcon onClick={() => handleRemove(index)} disabled={values.length === 1}></DeleteIcon>:""} 
                </div>
            ))}
            <AddIcon style={{ cursor: 'pointer' }} onClick={handleAdd} />

        </div>
    );
};
